import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchInquiry,
    updateClientInquiry,
    clearError,
    enrollInquiryAsPatient,
    fetchInquiries,
} from "../../store/slices/inquirySlice";
import Swal from "sweetalert2";
import EnquirerInfo from "../Patient/manage/EnquiryForm/EnquirerInfo";
import ClientInfo from "../Patient/manage/EnquiryForm/ClientInfo";
import Medications from "../Patient/manage/EnquiryForm/Medications";
import PhysicalHealth from "../Patient/manage/EnquiryForm/PhysicalHealth";
import RiskAssessment from "../Patient/manage/EnquiryForm/RiskAssessment";
import AggressionHistory from "../Patient/manage/EnquiryForm/AggressionHistory";
import ClientBehavior from "../Patient/manage/EnquiryForm/ClientBehavior";
import TreatmentPlan from "../Patient/manage/EnquiryForm/TreatmentPlan";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import MainLayout from "../../components/layout/MainLayout";
import { getApiErrorMessage } from "../../utils/apiError";
const EditInquiry = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isLoading, error, currentInquiry } = useSelector(
        (state) => state.inquiries
    );

    const canEditProgram =
        currentInquiry &&
        !currentInquiry.master?.patient_id &&
        !currentInquiry.master?.case_id &&
        [1, 3, "1", "3"].includes(currentInquiry.master?.program_master_id);

    const [activeTab, setActiveTab] = useState("enquirer-info");
    const [selectedProgram, setSelectedProgram] = useState("");
    const [formData, setFormData] = useState({
        contactMethod: "",
        inquirerName: "",
        relationWithClient: "",
        phone1: "",
        phone2: "",
        email: "",
        address: "",
        howHeard: [],
        referredBy: { psychiatrist: "", psychologist: "", otherMedical: "" },
        otherSource: "",
        clientName: "",
        clientGender: "",
        clientDOB: "",
        client_cnic: "",
        client_phone: "",
        client_email: "",
        client_address: "",
        clientEducation: "",
        clientBirthOrder: "",
        clientSiblings: "",
        familyMentalIllness: "",
        familyMentalIllnessDetails: "",
        diagnosis: "",
        diagnosisSince: "",
        currentCare: "",
        trhServices: "",
        trhServicesDetails: "",
        substanceUse: "",
        substanceUseDetails: "",
        presentingComplaints: "",
        medications: [{ name: "", dosage: "" }],
        prescribedBy: "",
        prescriptionDate: "",
        prevServices: [],
        otherService: "",
        healthIssues: [],
        prevHospitalizations: [{ hospital: "", duration: "", consultant: "" }],
        medicalConditions: "",
        medicalConditionsDetails: "",
        healthIssues: [],
        otherHealthIssue: "",
        illnessHistory: "",
        expectations: "",
        suicidalThoughts: "",
        suicideFrequency: "",
        suicidePlans: "",
        suicideAttempts: "",
        suicideAttemptsDetails: "",
        desireEscape: "",
        escapeAttempts: "",
        escapeAttemptsDetails: "",
        historyAggression: "",
        historyAggressionDetails: "",
        harmToOthers: "",
        harmToOthersDetails: "",
        selfHarmHistory: "",
        selfHarmHistoryDetails: "",
        selfHarmUrges: "",
        selfHarmUrgesDetails: "",
        recommendedFor: [],
        opdDetails: "",
        followUpNotes: "",
        programType: "",
        prev_aggression: "",
        last_episode: "",
        incident_provoked: "",
        regret_incident: "",
        show_denial: "",
        episode_description: "",
        cope_stress: "",
        client_general_behavior: "",
        impulsive_behavior: "",
        impulsive_example_1: "",
        impulsive_example_2: "",
        impulsive_example_3: "",
        symptoms: "",
        rehab_expectations: "",
        fear_aggression: "",
        psychiatrist_note: "",
        treatmentOption: "",
        reason: "",
        amount: "",
        payment_status: "",
        reference_no: "",
        payment_date: "",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(fetchInquiry(id));
        dispatch(clearError());
    }, [dispatch, id]);

    useEffect(() => {
        if (currentInquiry) {
            setSelectedProgram(String(currentInquiry.master?.program_master_id || ""));
            setFormData((prev) => ({
                ...prev,
                ...currentInquiry.master,
                howHeard:
                    currentInquiry.hearAboutUs?.map((h) => h.value) || prev.howHeard,
                referredBy: {
                    psychiatrist:
                        currentInquiry.hearAboutUs?.find((h) =>
                            h.value.includes("Psychiatrist")
                        )?.name || "",
                    psychologist:
                        currentInquiry.hearAboutUs?.find((h) =>
                            h.value.includes("Psychologist")
                        )?.name || "",
                    otherMedical:
                        currentInquiry.hearAboutUs?.find((h) =>
                            h.value.includes("Medical Practitioner")
                        )?.name || "",
                },
                otherSource:
                    currentInquiry.hearAboutUs?.find((h) => h.value === "Other")
                        ?.name || "",
                programType: currentInquiry.program?.name || currentInquiry.master?.program?.name || "N/A",
                contactMethod: currentInquiry.master?.contact_method || "",
                inquirerName: currentInquiry.master?.inquirer_name || "",
                relationWithClient: currentInquiry.master?.relation_with_client || "",
                clientName: currentInquiry.clientInformation?.client_name || "",
                clientGender: currentInquiry.clientInformation?.client_gender || "",
                clientEducation: currentInquiry.clientInformation?.client_education || "",
                clientDOB: currentInquiry.clientInformation?.client_dob || "",
                client_cnic: currentInquiry.clientInformation?.client_cnic || "",
                client_phone: currentInquiry.clientInformation?.client_phone || "",
                client_email: currentInquiry.clientInformation?.client_email || "",
                client_address: currentInquiry.clientInformation?.client_address || "",
                clientBirthOrder: currentInquiry.clientInformation?.client_birth_order || "",
                clientSiblings: currentInquiry.clientInformation?.client_siblings || "",
                familyMentalIllness: currentInquiry.clientInformation?.family_mental_illness || "",
                familyMentalIllnessDetails: currentInquiry.clientInformation?.family_mental_illness_details || "",
                diagnosis: currentInquiry.clientInformation?.diagnosis || "",
                diagnosisSince: currentInquiry.clientInformation?.diagnosis_since || "",
                currentCare: currentInquiry.clientInformation?.current_care || "",
                presentingComplaints: currentInquiry.clientInformation?.presenting_complaints || "",
                medications:
                    currentInquiry.medicationsList?.map((m) => ({
                        name: m.name || "",
                        dosage: m.dosage || "",
                    })) || prev.medications,
                prescribedBy: currentInquiry.clientMedications?.prescribed_by || "",
                prescriptionDate: currentInquiry.clientMedications?.prescription_date || "",
                prevServices: currentInquiry.clientMedications?.prev_services
                    ? JSON.parse(currentInquiry.clientMedications.prev_services)
                    : [],
                otherService: currentInquiry.clientMedications?.other_service || "",
                prevHospitalizations:
                    currentInquiry.prevHospitalizations?.map((h) => ({
                        hospital: h.hospital || "",
                        duration: h.duration || "",
                        consultant: h.consultant || "",
                    })) || [{ hospital: "", duration: "", consultant: "" }],
                trhServices: currentInquiry.clientInformation?.trh_services || "",
                trhServicesDetails: currentInquiry.clientInformation?.trh_services_details || "",
                substanceUse: currentInquiry.clientInformation?.substance_use || "",
                substanceUseDetails: currentInquiry.clientInformation?.substance_use_details || "",
                medicalConditions: currentInquiry.clientHistory?.medical_conditions || "",
                medicalConditionsDetails: currentInquiry.clientHistory?.medical_conditions_details || "",
                healthIssues:
                    currentInquiry.clientHistory?.experienced_issues
                        ? currentInquiry.clientHistory.experienced_issues.split(",").map((item) => item.trim())
                        : [],
                otherHealthIssue: currentInquiry.clientHistory?.other_health_issue || "",
                illnessHistory: currentInquiry.clientHistory?.illness_history || "",
                expectations: currentInquiry.clientHistory?.expectations || "",
                suicidalThoughts: currentInquiry.riskForm?.suicidal_thoughts || "",
                suicideFrequency: currentInquiry.riskForm?.frequency_suicidal_thoughts || "",
                suicidePlans: currentInquiry.riskForm?.current_or_past_suicide_plans || "",
                suicideAttempts: currentInquiry.riskForm?.previous_suicide_attempts || "",
                suicideAttemptsDetails: currentInquiry.riskForm?.previous_suicide_attempts_details || "",
                desireEscape: currentInquiry.riskForm?.desire_to_escape || "",
                escapeAttempts: currentInquiry.riskForm?.past_escape_attempts || "",
                escapeAttemptsDetails: currentInquiry.riskForm?.past_escape_attempts_details || "",
                historyAggression: currentInquiry.riskForm?.history_of_aggression || "",
                historyAggressionDetails: currentInquiry.riskForm?.history_of_aggression_details || "",
                harmToOthers: currentInquiry.riskForm?.current_risk_of_harm_to_others || "",
                harmToOthersDetails: currentInquiry.riskForm?.specific_individuals || "",
                selfHarmHistory: currentInquiry.riskForm?.history_of_self_harm || "",
                selfHarmHistoryDetails: currentInquiry.riskForm?.history_of_self_harm_details || "",
                selfHarmUrges: currentInquiry.riskForm?.current_self_harm_urges || "",
                selfHarmUrgesDetails: currentInquiry.riskForm?.specific_self_harm_actions || "",
                recommendedFor: Array.isArray(currentInquiry.riskForm?.recommended_for)
                    ? currentInquiry.riskForm.recommended_for
                    : currentInquiry.riskForm?.recommended_for
                        ? String(currentInquiry.riskForm.recommended_for)
                            .split(",")
                            .map((item) => item.trim())
                        : [],
                opdDetails: currentInquiry.riskForm?.opd_details || "",
                followUpNotes: currentInquiry.riskForm?.follow_up_notes || "",
                prev_aggression:
                    currentInquiry.aggressionHistory?.prev_aggression || "",
                last_episode: currentInquiry.aggressionHistory?.last_episode || "",
                incident_provoked:
                    currentInquiry.aggressionHistory?.incident_provoked || "",
                regret_incident:
                    currentInquiry.aggressionHistory?.regret_incident || "",
                show_denial: currentInquiry.aggressionHistory?.show_denial || "",
                episode_description:
                    currentInquiry.aggressionHistory?.episode_description || "",
                cope_stress: currentInquiry.aggressionHistory?.cope_stress || "",
                client_general_behavior:
                    currentInquiry.clientBehavior?.client_general_behavior || "",
                impulsive_behavior:
                    currentInquiry.clientBehavior?.impulsive_behavior || "",
                impulsive_example_1:
                    currentInquiry.clientBehavior?.impulsive_example_1 || "",
                impulsive_example_2:
                    currentInquiry.clientBehavior?.impulsive_example_2 || "",
                impulsive_example_3:
                    currentInquiry.clientBehavior?.impulsive_example_3 || "",
                symptoms: currentInquiry.clientBehavior?.symptoms || "",
                rehab_expectations:
                    currentInquiry.clientBehavior?.rehab_expectations || "",
                fear_aggression:
                    currentInquiry.clientBehavior?.fear_aggression || "",
                psychiatrist_note:
                    currentInquiry.clientBehavior?.psychiatrist_note || "",
                treatmentOption:
                    currentInquiry.treatmentPlan?.treatment_option || "",
                reason:
                    currentInquiry.treatmentPlan?.reason || "",
                amount: currentInquiry.master?.amount || "",
                payment_status: currentInquiry.master?.payment_status || "",
                reference_no: currentInquiry.master?.reference_no || "",
                payment_date: currentInquiry.master?.payment_date || "",
            }));
        }
    }, [currentInquiry]);

    // ================= VALIDATION FUNCTIONS =================

    const validateEnquirerInfo = () => {
        const newErrors = {};
        if (!formData.contactMethod) {
            newErrors.contactMethod = "Contact method is required";
        }
        if (!formData.inquirerName?.trim()) {
            newErrors.inquirerName = "Inquirer name is required";
        }
        if (!formData.phone1?.trim()) {
            newErrors.phone1 = "Phone number is required";
        }
        if (!formData.email?.trim()) {
            newErrors.email = "Email is required";
        }
        if (!formData.relationWithClient) {
            newErrors.relationWithClient = "Relation with client is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ===== FORMAT VALIDATIONS (email, phone, cnic, name) =====
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateEnquirerFormats = () => {
        const newErrors = {};
        if (formData.inquirerName && formData.inquirerName.trim().length < 2) {
            newErrors.inquirerName = "Name is too short";
        }
        if (formData.phone1 && formData.phone1.replace(/\D/g, "").length < 7) {
            newErrors.phone1 = "Invalid phone number";
        }
        if (formData.email && !emailRegex.test(formData.email)) {
            newErrors.email = "Invalid email address";
        }
        setErrors((prev) => ({ ...prev, ...newErrors }));
        return Object.keys(newErrors).length === 0;
    };

    const validateClientInfo = () => {
        const newErrors = {};
        if (!formData.clientName?.trim()) {
            newErrors.clientName = "Client name is required";
        }
        if (!formData.clientGender?.trim()) {
            newErrors.clientGender = "Gender is required";
        }
        if (!formData.clientDOB?.trim()) {
            newErrors.clientDOB = "Date of birth is required";
        }
        if (!formData.client_phone?.trim()) {
            newErrors.client_phone = "Phone number is required";
        }
        if (!formData.client_cnic?.trim()) {
            newErrors.client_cnic = "CNIC is required";
        }
        if (!formData.client_email?.trim()) {
            newErrors.client_email = "Email is required";
        }
        if (!formData.client_address?.trim()) {
            newErrors.client_address = "Address is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateClientFormats = () => {
        const newErrors = {};
        if (formData.clientName && formData.clientName.trim().length < 2) {
            newErrors.clientName = "Name is too short";
        }
        if (formData.client_phone && formData.client_phone.replace(/\D/g, "").length < 7) {
            newErrors.client_phone = "Invalid phone number";
        }
        if (formData.client_email && !emailRegex.test(formData.client_email)) {
            newErrors.client_email = "Invalid email address";
        }
        const cnicDigits = (formData.client_cnic || "").replace(/\D/g, "");
        if (formData.client_cnic && cnicDigits.length !== 13) {
            newErrors.client_cnic = "Invalid CNIC format";
        }
        setErrors((prev) => ({ ...prev, ...newErrors }));
        return Object.keys(newErrors).length === 0;
    };

    const validateMedications = () => {
        const newErrors = {};
        if (!formData.medications?.[0]?.name?.trim()) {
            newErrors.medications = "At least one medication is required";
        }
        if (!formData.prescribedBy?.trim()) {
            newErrors.prescribedBy = "Prescribed by is required";
        }
        if (!formData.prescriptionDate) {
            newErrors.prescriptionDate = "Prescription date is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validatePhysicalHealth = () => {
        const newErrors = {};
        if (!formData.medicalConditions) {
            newErrors.medicalConditions = "Please specify if there are known medical conditions";
        }
        if (formData.medicalConditions === "Yes" && !formData.medicalConditionsDetails?.trim()) {
            newErrors.medicalConditionsDetails = "Please specify the medical conditions";
        }
        if (!formData.illnessHistory?.trim()) {
            newErrors.illnessHistory = "Brief history of illness is required";
        }
        if (!formData.expectations?.trim()) {
            newErrors.expectations = "Expectations from rehabilitation services is required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateRiskAssessment = () => {
        const newErrors = {};
        if (!formData.suicidalThoughts) {
            newErrors.suicidalThoughts = "Please specify if there are suicidal thoughts";
        }
        if (formData.suicidalThoughts === "Yes" && !formData.suicideFrequency) {
            newErrors.suicideFrequency = "Please specify frequency of suicidal thoughts";
        }
        if (!formData.suicidePlans) {
            newErrors.suicidePlans = "Please specify if there are current or past suicide plans";
        }
        if (!formData.suicideAttempts) {
            newErrors.suicideAttempts = "Please specify if there were previous suicide attempts";
        }
        if (formData.suicideAttempts === "Yes" && !formData.suicideAttemptsDetails?.trim()) {
            newErrors.suicideAttemptsDetails = "Please provide details of previous suicide attempts";
        }
        if (!formData.desireEscape) {
            newErrors.desireEscape = "Please specify if there is a desire to escape";
        }
        if (!formData.escapeAttempts) {
            newErrors.escapeAttempts = "Please specify if there were past escape attempts";
        }
        if (formData.escapeAttempts === "Yes" && !formData.escapeAttemptsDetails?.trim()) {
            newErrors.escapeAttemptsDetails = "Please provide details of past escape attempts";
        }
        if (!formData.historyAggression) {
            newErrors.historyAggression = "Please specify if there is a history of aggression";
        }
        if (formData.historyAggression === "Yes" && !formData.historyAggressionDetails?.trim()) {
            newErrors.historyAggressionDetails = "Please provide details of history of aggression";
        }
        if (!formData.harmToOthers) {
            newErrors.harmToOthers = "Please specify if there is a current risk of harm to others";
        }
        if (formData.harmToOthers === "Yes" && !formData.harmToOthersDetails?.trim()) {
            newErrors.harmToOthersDetails = "Please specify any specific individuals at risk";
        }
        if (!formData.selfHarmHistory) {
            newErrors.selfHarmHistory = "Please specify if there is a history of self-harm";
        }
        if (formData.selfHarmHistory === "Yes" && !formData.selfHarmHistoryDetails?.trim()) {
            newErrors.selfHarmHistoryDetails = "Please provide details of history of self-harm";
        }
        if (!formData.selfHarmUrges) {
            newErrors.selfHarmUrges = "Please specify if there are current self-harm urges";
        }
        if (formData.selfHarmUrges === "Yes" && !formData.selfHarmUrgesDetails?.trim()) {
            newErrors.selfHarmUrgesDetails = "Please specify specific actions considered";
        }
        if (formData.recommendedFor.length === 0) {
            newErrors.recommendedFor = "Please select at least one recommendation";
        }
        if (formData.recommendedFor.includes("OPD Services outside TRH") && !formData.opdDetails?.trim()) {
            newErrors.opdDetails = "Please provide details for OPD services";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateAggressionHistory = () => {
        const newErrors = {};
        if (!formData.prev_aggression) {
            newErrors.prev_aggression = "Please specify if there was a previous episode of aggression/violence";
        }
        if (formData.prev_aggression === "Yes") {
            if (!formData.last_episode?.trim()) {
                newErrors.last_episode = "Please specify when was the last episode";
            }
            if (!formData.incident_provoked) {
                newErrors.incident_provoked = "Please specify if the incident was provoked";
            }
            if (!formData.regret_incident) {
                newErrors.regret_incident = "Please specify if he/she regrets the incident";
            }
            if (!formData.show_denial) {
                newErrors.show_denial = "Please specify if he/she shows denial";
            }
            if (!formData.episode_description?.trim()) {
                newErrors.episode_description = "Please describe the episode briefly";
            }
        }
        if (!formData.cope_stress?.trim()) {
            newErrors.cope_stress = "Please describe how the client handles/copes with stress";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateClientBehavior = () => {
        const newErrors = {};
        if (!formData.client_general_behavior) {
            newErrors.client_general_behavior = "Please select the client's general behavior";
        }
        if (!formData.impulsive_behavior) {
            newErrors.impulsive_behavior = "Please specify if the client exhibits impulsive behavior";
        }
        if (formData.impulsive_behavior === "Yes") {
            if (!formData.impulsive_example_1?.trim()) {
                newErrors.impulsive_example_1 = "Please provide first example of impulsive behavior";
            }
            if (!formData.impulsive_example_2?.trim()) {
                newErrors.impulsive_example_2 = "Please provide second example of impulsive behavior";
            }
            if (!formData.impulsive_example_3?.trim()) {
                newErrors.impulsive_example_3 = "Please provide third example of impulsive behavior";
            }
        }
        if (!formData.symptoms?.trim()) {
            newErrors.symptoms = "Please describe the symptoms";
        }
        if (!formData.rehab_expectations?.trim()) {
            newErrors.rehab_expectations = "Please describe expectations from rehabilitation services";
        }
        if (!formData.fear_aggression) {
            newErrors.fear_aggression = "Please specify if you fear another episode of violence/aggression";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateTreatmentPlan = () => {
        const newErrors = {};
        if (!formData.treatmentOption) {
            newErrors.treatmentOption = "Please select a treatment plan";
        }
        if (!formData.reason?.trim()) {
            newErrors.reason = "Please provide a reason for the selected treatment plan";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ================= NEXT BUTTON HANDLERS =================

    const handleEnquirerNext = () => {
        if (!validateEnquirerInfo()) return;
        if (!validateEnquirerFormats()) return;
        setActiveTab("client-info");
    };

    const handleClientNext = () => {
        if (!validateClientInfo()) return;
        if (!validateClientFormats()) return;
        setActiveTab("medications");
    };

    const handleMedicationsNext = () => {
        if (!validateMedications()) return;
        if (selectedProgram === "2") {
            setActiveTab("aggression-history");
        } else {
            setActiveTab("physical-health");
        }
    };

    const handlePhysicalHealthNext = () => {
        if (validatePhysicalHealth()) {
            setActiveTab("risk-assessment");
        }
    };

    const handleAggressionHistoryNext = () => {
        if (validateAggressionHistory()) {
            setActiveTab("client-behavior");
        }
    };

    const handleClientBehaviorNext = () => {
        if (validateClientBehavior()) {
            setActiveTab("treatment-plan");
        }
    };

    // ================= FORM HANDLERS =================
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let finalValue = value;

        // ---------- 1. APPLY MASKING ----------
        if (name === "client_cnic") {
            const digits = value.replace(/\D/g, "").slice(0, 13);
            if (digits.length <= 5) finalValue = digits;
            else if (digits.length <= 12) finalValue = `${digits.slice(0, 5)}-${digits.slice(5)}`;
            else finalValue = `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12, 13)}`;
        }

        if (["phone1", "phone2", "client_phone"].includes(name)) {
            const digits = value.replace(/\D/g, "").slice(0, 11);
            if (digits.length <= 4) finalValue = digits;
            else finalValue = `${digits.slice(0, 4)}-${digits.slice(4)}`;
        }

        // ---------- 2. INLINE EMAIL VALIDATION ----------
        if (name === "client_email" || name === "email") {
            let errorMsg = "";
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value && !value.includes("@")) {
                errorMsg = "Email must contain '@'";
            } else if (value && !emailRegex.test(value)) {
                errorMsg = "Invalid email format";
            }
            setErrors((prev) => ({ ...prev, [name]: errorMsg }));
        }

        // Clear generic errors for other fields when user starts typing
        if (errors[name] && name !== "client_email" && name !== "email") {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }

        // ---------- 3. CHECKBOX HANDLING ----------
        if (type === "checkbox") {
            const updatedArray = checked
                ? [...formData[name], value]
                : formData[name].filter((item) => item !== value);

            setFormData((prev) => ({ ...prev, [name]: updatedArray }));
            return;
        }

        // ---------- 4. REFERRED BY HANDLING ----------
        if (name.includes("referredBy")) {
            const [, subKey] = name.split(".");
            setFormData((prev) => ({
                ...prev,
                referredBy: { ...prev.referredBy, [subKey]: finalValue },
            }));
            return;
        }

        // ---------- 5. ARRAY FIELDS (Meds/Hosp) ----------
        if (name.includes("medications") || name.includes("prevHospitalizations")) {
            const [field, index, subField] = name.split(".");
            const updatedArray = [...formData[field]];
            updatedArray[index] = { ...updatedArray[index], [subField]: finalValue };
            setFormData((prev) => ({ ...prev, [field]: updatedArray }));
            return;
        }

        // ---------- 6. DEFAULT STATE UPDATE ----------
        setFormData((prev) => ({
            ...prev,
            [name]: finalValue,
        }));
    };
    const addMedication = () => {
        setFormData({
            ...formData,
            medications: [...(formData.medications || []), { name: "", dosage: "" }],
        });
    };

    const removeMedication = (index) => {
        setFormData({
            ...formData,
            medications: (formData.medications || []).filter((_, i) => i !== index),
        });
    };

    const addHospitalization = () => {
        setFormData({
            ...formData,
            prevHospitalizations: [...(formData.prevHospitalizations || []), { hospital: "", duration: "", consultant: "" }],
        });
    };

    const removeHospitalization = (index) => {
        setFormData({
            ...formData,
            prevHospitalizations: (formData.prevHospitalizations || []).filter((_, i) => i !== index),
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate based on selected program
        let isValid = false;

        if (selectedProgram === "2") {
            isValid = validateTreatmentPlan();
        } else {
            isValid = validateRiskAssessment();
        }

        if (!isValid) {
            Swal.fire({
                title: "Incomplete Form",
                text: "Please fill in all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            const processedData = { ...formData };

            if (processedData.suicideAttempts === "No") processedData.suicideAttemptsDetails = null;
            if (processedData.escapeAttempts === "No") processedData.escapeAttemptsDetails = null;
            if (processedData.historyAggression === "No") processedData.historyAggressionDetails = null;
            if (processedData.harmToOthers === "No") processedData.harmToOthersDetails = null;
            if (processedData.selfHarmHistory === "No") processedData.selfHarmHistoryDetails = null;
            if (processedData.selfHarmUrges === "No") processedData.selfHarmUrgesDetails = null;

            const payload = {
                ...processedData,
                recommendedFor: Array.isArray(processedData.recommendedFor)
                    ? processedData.recommendedFor
                    : String(processedData.recommendedFor).split(",").map((x) => x.trim()),
                suicidal_thoughts: processedData.suicidalThoughts,
                frequency_suicidal_thoughts: processedData.suicideFrequency,
                current_or_past_suicide_plans: processedData.suicidePlans,
                previous_suicide_attempts: processedData.suicideAttempts,
                previous_suicide_attempts_details: processedData.suicideAttemptsDetails,
                desire_to_escape: processedData.desireEscape,
                past_escape_attempts: processedData.escapeAttempts,
                past_escape_attempts_details: processedData.escapeAttemptsDetails,
                history_of_aggression: processedData.historyAggression,
                history_of_aggression_details: processedData.historyAggressionDetails,
                history_of_self_harm: processedData.selfHarmHistory,
                history_of_self_harm_details: processedData.selfHarmHistoryDetails,
                current_self_harm_urges: processedData.selfHarmUrges,
                specific_self_harm_actions: processedData.selfHarmUrgesDetails,
                current_risk_of_harm_to_others: processedData.harmToOthers,
                specific_individuals: processedData.harmToOthersDetails,
                treatment_option: formData.treatmentOption,
            };

            await dispatch(updateClientInquiry({ id, inquiryData: payload })).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Inquiry updated successfully!",
                icon: "success",
                timer: 1500,
            }).then(() => navigate("/patients"));
        } catch (error) {
            Swal.fire({
                title: "Error!",
                text: getApiErrorMessage(error, "Failed to update inquiry."),
                icon: "error",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="d-flex justify-content-between align-items-center">
                    <Breadcrumbs />
                    <Link
                        to={`/inquiry/print/${id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary"
                    >
                        <i className="ri-printer-line me-1"></i> Print
                    </Link>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="bs-stepper wizard-vertical">
                            <div className="bs-stepper-header">
                                {(
                                    ["1", "3"].includes(selectedProgram)
                                        ? [
                                            { key: "enquirer-info", icon: "ri-contacts-line", title: "Enquirer Info" },
                                            { key: "client-info", icon: "ri-user-line", title: "Client Info" },
                                            { key: "medications", icon: "ri-medicine-bottle-line", title: "Medications" },
                                            { key: "physical-health", icon: "ri-heart-line", title: "Physical Health" },
                                            { key: "risk-assessment", icon: "ri-shield-line", title: "Risk Assessment" },
                                        ]
                                        : selectedProgram === "2"
                                            ? [
                                                { key: "enquirer-info", icon: "ri-contacts-line", title: "Enquirer Info" },
                                                { key: "client-info", icon: "ri-user-line", title: "Client Info" },
                                                { key: "medications", icon: "ri-medicine-bottle-line", title: "Medications" },
                                                { key: "aggression-history", icon: "ri-fire-line", title: "Aggression History" },
                                                { key: "client-behavior", icon: "ri-mental-health-line", title: "Client Behavior" },
                                                { key: "treatment-plan", icon: "ri-file-list-3-line", title: "Treatment Plan" },
                                            ]
                                            : []
                                ).map((tab) => (
                                    <div className="step" key={tab.key}>
                                        <button
                                            type="button"
                                            className={`step-trigger ${activeTab === tab.key ? "active" : ""}`}
                                            onClick={() => setActiveTab(tab.key)}
                                        >
                                            <span className="avatar">
                                                <span className="avatar-initial rounded-2 bg-primary text-white">
                                                    <i className={`${tab.icon} ri-24px`}></i>
                                                </span>
                                            </span>
                                            <span className="bs-stepper-label">
                                                <span className="bs-stepper-title">{tab.title}</span>
                                            </span>
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <div className="bs-stepper-content">
                                <div className="d-flex justify-content-end mb-4">
                                    <div className="col-md-3">
                                        <select
                                            className="form-select"
                                            name="program_master_id"
                                            value={selectedProgram}
                                            disabled={!canEditProgram}
                                            style={!canEditProgram ? { cursor: "not-allowed" } : {}}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setSelectedProgram(val);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    program_master_id: parseInt(val),
                                                    programType: val === "1" ? "Day Rehab" : "Residential Rehab"
                                                }));
                                            }}
                                        >
                                            {canEditProgram ? (
                                                <>
                                                    <option value="1">Day Rehab</option>
                                                    <option value="3">Residential Rehab</option>
                                                </>
                                            ) : (
                                                <option value={selectedProgram}>
                                                    {formData?.programType || "N/A"}
                                                </option>
                                            )}
                                        </select>
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    {activeTab === "enquirer-info" && (
                                        <EnquirerInfo
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            errors={errors}
                                            onNext={handleEnquirerNext}
                                        />
                                    )}

                                    {activeTab === "client-info" && (
                                        <ClientInfo
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            isAdd={false}
                                            errors={errors}
                                            onNext={handleClientNext}
                                        />
                                    )}

                                    {activeTab === "medications" && (
                                        <Medications
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            addMedication={addMedication}
                                            removeMedication={removeMedication}
                                            addHospitalization={addHospitalization}
                                            removeHospitalization={removeHospitalization}
                                            errors={errors}
                                            onNext={handleMedicationsNext}
                                        />
                                    )}

                                    {["1", "3"].includes(selectedProgram) && activeTab === "physical-health" && (
                                        <PhysicalHealth
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            errors={errors}
                                            onNext={handlePhysicalHealthNext}
                                        />
                                    )}

                                    {["1", "3"].includes(selectedProgram) && activeTab === "risk-assessment" && (
                                        <RiskAssessment
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            errors={errors}
                                        />
                                    )}

                                    {selectedProgram === "2" && activeTab === "aggression-history" && (
                                        <AggressionHistory
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            errors={errors}
                                            onNext={handleAggressionHistoryNext}
                                        />
                                    )}

                                    {selectedProgram === "2" && activeTab === "client-behavior" && (
                                        <ClientBehavior
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            errors={errors}
                                            onNext={handleClientBehaviorNext}
                                        />
                                    )}

                                    {selectedProgram === "2" && activeTab === "treatment-plan" && (
                                        <TreatmentPlan
                                            formData={formData}
                                            handleChange={handleChange}
                                            setActiveTab={setActiveTab}
                                            selectedProgram={selectedProgram}
                                            errors={errors}
                                        />
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default EditInquiry;